const Icon = ({title, direction, nodeRef, ...props}) => (
    <div {...props} ref={nodeRef}>
        <i className={`icon-slider-${direction}`} title={title} />
    </div>
);

Icon.defaultProps = {
    direction: 'down',
    nodeRef: null,
};

export default Icon;
